!function(i,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(i=i||self).Delaunator=t()}(this,function(){"use strict";var i=Math.pow(2,-52),t=new Uint32Array(512),r=function(i){var t=i.length>>1;if(t>0&&"number"!=typeof i[0])throw new Error("Expected coords to contain numbers.");this.coords=i;var r=Math.max(2*t-5,0);this._triangles=new Uint32Array(3*r),this._halfedges=new Int32Array(3*r),this._hashSize=Math.ceil(Math.sqrt(t)),this._hullPrev=new Uint32Array(t),this._hullNext=new Uint32Array(t),this._hullTri=new Uint32Array(t),this._hullHash=new Int32Array(this._hashSize).fill(-1),this._ids=new Uint32Array(t),this._dists=new Float64Array(t),this.update()};function s(i,t,r,s){var h=i-r,a=t-s;return h*h+a*a}function h(i,t,r,s,h,a){var e=(s-t)*(h-i),n=(r-i)*(a-t);return Math.abs(e-n)>=33306690738754716e-32*Math.abs(e+n)?e-n:0}function a(i,t,r,s,a,e){return(h(a,e,i,t,r,s)||h(i,t,r,s,a,e)||h(r,s,a,e,i,t))<0}function e(i,t,r,s,h,a){var e=r-i,n=s-t,l=h-i,o=a-t,f=e*e+n*n,_=l*l+o*o,d=.5/(e*o-n*l),v=(o*f-n*_)*d,u=(e*_-l*f)*d;return v*v+u*u}function n(i,t,r,s){if(s-r<=20)for(var h=r+1;h<=s;h++){for(var a=i[h],e=t[a],o=h-1;o>=r&&t[i[o]]>e;)i[o+1]=i[o--];i[o+1]=a}else{var f=r+1,_=s;l(i,r+s>>1,f),t[i[r]]>t[i[s]]&&l(i,r,s),t[i[f]]>t[i[s]]&&l(i,f,s),t[i[r]]>t[i[f]]&&l(i,r,f);for(var d=i[f],v=t[d];;){do{f++}while(t[i[f]]<v);do{_--}while(t[i[_]]>v);if(_<f)break;l(i,f,_)}i[r+1]=i[_],i[_]=d,s-f+1>=_-r?(n(i,t,f,s),n(i,t,r,_-1)):(n(i,t,r,_-1),n(i,t,f,s))}}function l(i,t,r){var s=i[t];i[t]=i[r],i[r]=s}function o(i){return i[0]}function f(i){return i[1]}return r.from=function(i,t,s){void 0===t&&(t=o),void 0===s&&(s=f);for(var h=i.length,a=new Float64Array(2*h),e=0;e<h;e++){var n=i[e];a[2*e]=t(n),a[2*e+1]=s(n)}return new r(a)},r.prototype.update=function(){for(var t=this.coords,r=this._hullPrev,h=this._hullNext,l=this._hullTri,o=this._hullHash,f=t.length>>1,_=1/0,d=1/0,v=-1/0,u=-1/0,y=0;y<f;y++){var g=t[2*y],c=t[2*y+1];g<_&&(_=g),c<d&&(d=c),g>v&&(v=g),c>u&&(u=c),this._ids[y]=y}for(var w,p,b,A=(_+v)/2,k=(d+u)/2,x=1/0,M=0;M<f;M++){var S=s(A,k,t[2*M],t[2*M+1]);S<x&&(w=M,x=S)}var z=t[2*w],U=t[2*w+1];x=1/0;for(var T=0;T<f;T++)if(T!==w){var m=s(z,U,t[2*T],t[2*T+1]);m<x&&m>0&&(p=T,x=m)}for(var K=t[2*p],L=t[2*p+1],P=1/0,E=0;E<f;E++)if(E!==w&&E!==p){var F=e(z,U,K,L,t[2*E],t[2*E+1]);F<P&&(b=E,P=F)}var H=t[2*b],I=t[2*b+1];if(P===1/0){for(var N=0;N<f;N++)this._dists[N]=t[2*N]-t[0]||t[2*N+1]-t[1];n(this._ids,this._dists,0,f-1);for(var j=new Uint32Array(f),q=0,D=0,B=-1/0;D<f;D++){var C=this._ids[D];this._dists[C]>B&&(j[q++]=C,B=this._dists[C])}return this.hull=j.subarray(0,q),this.triangles=new Uint32Array(0),void(this.halfedges=new Uint32Array(0))}if(a(z,U,K,L,H,I)){var G=p,J=K,O=L;p=b,K=H,L=I,b=G,H=J,I=O}var Q=function(i,t,r,s,h,a){var e=r-i,n=s-t,l=h-i,o=a-t,f=e*e+n*n,_=l*l+o*o,d=.5/(e*o-n*l);return{x:i+(o*f-n*_)*d,y:t+(e*_-l*f)*d}}(z,U,K,L,H,I);this._cx=Q.x,this._cy=Q.y;for(var R=0;R<f;R++)this._dists[R]=s(t[2*R],t[2*R+1],Q.x,Q.y);n(this._ids,this._dists,0,f-1),this._hullStart=w;var V=3;h[w]=r[b]=p,h[p]=r[w]=b,h[b]=r[p]=w,l[w]=0,l[p]=1,l[b]=2,o.fill(-1),o[this._hashKey(z,U)]=w,o[this._hashKey(K,L)]=p,o[this._hashKey(H,I)]=b,this.trianglesLen=0,this._addTriangle(w,p,b,-1,-1,-1);for(var W=0,X=void 0,Y=void 0;W<this._ids.length;W++){var Z=this._ids[W],$=t[2*Z],ii=t[2*Z+1];if(!(W>0&&Math.abs($-X)<=i&&Math.abs(ii-Y)<=i)&&(X=$,Y=ii,Z!==w&&Z!==p&&Z!==b)){for(var ti=0,ri=0,si=this._hashKey($,ii);ri<this._hashSize&&(-1===(ti=o[(si+ri)%this._hashSize])||ti===h[ti]);ri++);for(var hi=ti=r[ti],ai=void 0;ai=h[hi],!a($,ii,t[2*hi],t[2*hi+1],t[2*ai],t[2*ai+1]);)if((hi=ai)===ti){hi=-1;break}if(-1!==hi){var ei=this._addTriangle(hi,Z,h[hi],-1,-1,l[hi]);l[Z]=this._legalize(ei+2),l[hi]=ei,V++;for(var ni=h[hi];ai=h[ni],a($,ii,t[2*ni],t[2*ni+1],t[2*ai],t[2*ai+1]);)ei=this._addTriangle(ni,Z,ai,l[Z],-1,l[ni]),l[Z]=this._legalize(ei+2),h[ni]=ni,V--,ni=ai;if(hi===ti)for(;a($,ii,t[2*(ai=r[hi])],t[2*ai+1],t[2*hi],t[2*hi+1]);)ei=this._addTriangle(ai,Z,hi,-1,l[hi],l[ai]),this._legalize(ei+2),l[ai]=ei,h[hi]=hi,V--,hi=ai;this._hullStart=r[Z]=hi,h[hi]=r[ni]=Z,h[Z]=ni,o[this._hashKey($,ii)]=Z,o[this._hashKey(t[2*hi],t[2*hi+1])]=hi}}}this.hull=new Uint32Array(V);for(var li=0,oi=this._hullStart;li<V;li++)this.hull[li]=oi,oi=h[oi];this.triangles=this._triangles.subarray(0,this.trianglesLen),this.halfedges=this._halfedges.subarray(0,this.trianglesLen)},r.prototype._hashKey=function(i,t){return Math.floor((r=i-this._cx,s=t-this._cy,h=r/(Math.abs(r)+Math.abs(s)),(s>0?3-h:1+h)/4*this._hashSize))%this._hashSize;var r,s,h},r.prototype._legalize=function(i){for(var r,s,h,a,e,n,l,o,f,_,d,v,u,y,g,c,w=this._triangles,p=this._halfedges,b=this.coords,A=0,k=0;;){var x=p[i],M=i-i%3;if(k=M+(i+2)%3,-1!==x){var S=x-x%3,z=M+(i+1)%3,U=S+(x+2)%3,T=w[k],m=w[i],K=w[z],L=w[U];if(r=b[2*T],s=b[2*T+1],h=b[2*m],a=b[2*m+1],e=b[2*K],n=b[2*K+1],l=b[2*L],o=b[2*L+1],f=void 0,_=void 0,d=void 0,v=void 0,u=void 0,y=void 0,void 0,g=void 0,c=void 0,(f=r-l)*((v=a-o)*(c=(u=e-l)*u+(y=n-o)*y)-(g=(d=h-l)*d+v*v)*y)-(_=s-o)*(d*c-g*u)+(f*f+_*_)*(d*y-v*u)<0){w[i]=L,w[x]=T;var P=p[U];if(-1===P){var E=this._hullStart;do{if(this._hullTri[E]===U){this._hullTri[E]=i;break}E=this._hullPrev[E]}while(E!==this._hullStart)}this._link(i,P),this._link(x,p[k]),this._link(k,U);var F=S+(x+1)%3;A<t.length&&(t[A++]=F)}else{if(0===A)break;i=t[--A]}}else{if(0===A)break;i=t[--A]}}return k},r.prototype._link=function(i,t){this._halfedges[i]=t,-1!==t&&(this._halfedges[t]=i)},r.prototype._addTriangle=function(i,t,r,s,h,a){var e=this.trianglesLen;return this._triangles[e]=i,this._triangles[e+1]=t,this._triangles[e+2]=r,this._link(e,s),this._link(e+1,h),this._link(e+2,a),this.trianglesLen+=3,e},r});
import * as THREE from "../../libs/three.js/build/three.module.js";
import {TextSprite} from "../TextSprite.js";
import {Utils} from "../utils.js";
import {Line2} from "../../libs/three.js/lines/Line2.js";
import {LineGeometry} from "../../libs/three.js/lines/LineGeometry.js";
import {LineMaterial} from "../../libs/three.js/lines/LineMaterial.js";
let showSnapValue = true;

function formatLabelNumberForLanguage(value, language) {
	if (language !== 'da') {
		return value;
	}

	const [integerPart, ...decimalParts] = value.split('.');
	const formattedIntegerPart = integerPart.replace(/,/g, '.');

	if (decimalParts.length === 0) {
		return formattedIntegerPart;
	}

	return `${formattedIntegerPart},${decimalParts.join('.')}`;
}

function createHeightLine(){
	let lineGeometry = new LineGeometry();

	lineGeometry.setPositions([
		0, 0, 0,
		0, 0, 0,
	]);

	let lineMaterial = new LineMaterial({ 
		color: 0x00ff00, 
		dashSize: 5, 
		gapSize: 2,
		linewidth: 2, 
		resolution:  new THREE.Vector2(1000, 1000),
	});

	lineMaterial.depthTest = false;
	const heightEdge = new Line2(lineGeometry, lineMaterial);
	heightEdge.visible = false;

	//this.add(this.heightEdge);
	
	return heightEdge;
}

function createHeightLabel(){
	const heightLabel = new TextSprite('');

	heightLabel.setTextColor({r: 34, g: 34, b: 34, a: 1.0});
	heightLabel.setBorderColor({r: 0, g: 115, b: 169, a: 1.0});
	heightLabel.setBackgroundColor({r: 255, g: 255, b: 255, a: 1.0});
	heightLabel.fontsize = 16;
	heightLabel.material.depthTest = false;
	heightLabel.material.opacity = 1;
	heightLabel.visible = false;

	return heightLabel;
}

function createAreaLabel(){
	const areaLabel = new TextSprite('');

	areaLabel.setTextColor({r: 34, g: 34, b: 34, a: 1.0});
	areaLabel.setBorderColor({r: 0, g: 115, b: 169, a: 1.0});
	areaLabel.setBackgroundColor({r: 255, g: 255, b: 255, a: 1.0});
	areaLabel.fontsize = 16;
	areaLabel.material.depthTest = false;
	areaLabel.material.opacity = 1;
	areaLabel.visible = false;
	
	return areaLabel;
}

function createAreaFill(){
	const geometry = new THREE.BufferGeometry();
	const material = new THREE.MeshBasicMaterial({
		color: 0x90ee90,
		transparent: true,
		opacity: 0.18,
		side: THREE.DoubleSide,
		depthTest: false,
		depthWrite: false,
	});

	const areaFill = new THREE.Mesh(geometry, material);
	areaFill.visible = false;
	areaFill.frustumCulled = false;
	areaFill.renderOrder = -1;

	return areaFill;
}

function createCircleRadiusLabel(){
	const circleRadiusLabel = new TextSprite("");

	circleRadiusLabel.setTextColor({r: 34, g: 34, b: 34, a: 1.0});
	circleRadiusLabel.setBorderColor({r: 0, g: 115, b: 169, a: 1.0});
	circleRadiusLabel.setBackgroundColor({r: 255, g: 255, b: 255, a: 1.0});
	circleRadiusLabel.fontsize = 16;
	circleRadiusLabel.material.depthTest = false;
	circleRadiusLabel.material.opacity = 1;
	circleRadiusLabel.visible = false;
	
	return circleRadiusLabel;
}

function createCircleRadiusLine(){
	const lineGeometry = new LineGeometry();

	lineGeometry.setPositions([
		0, 0, 0,
		0, 0, 0,
	]);

	const lineMaterial = new LineMaterial({ 
		color: 0xff0000, 
		linewidth: 2, 
		resolution:  new THREE.Vector2(1000, 1000),
		gapSize: 1,
		dashed: true,
	});

	lineMaterial.depthTest = false;

	const circleRadiusLine = new Line2(lineGeometry, lineMaterial);
	circleRadiusLine.visible = false;

	return circleRadiusLine;
}

function createCircleLine(){
	const coordinates = [];

	let n = 128;
	for(let i = 0; i <= n; i++){
		let u0 = 2 * Math.PI * (i / n);
		let u1 = 2 * Math.PI * (i + 1) / n;

		let p0 = new THREE.Vector3(
			Math.cos(u0), 
			Math.sin(u0), 
			0
		);

		let p1 = new THREE.Vector3(
			Math.cos(u1), 
			Math.sin(u1), 
			0
		);

		coordinates.push(
			...p0.toArray(),
			...p1.toArray(),
		);
	}

	const geometry = new LineGeometry();
	geometry.setPositions(coordinates);

	const material = new LineMaterial({ 
		color: 0xff0000, 
		dashSize: 5, 
		gapSize: 2,
		linewidth: 2, 
		resolution:  new THREE.Vector2(1000, 1000),
	});

	material.depthTest = false;

	const circleLine = new Line2(geometry, material);
	circleLine.visible = false;
	circleLine.computeLineDistances();

	return circleLine;
}

function createCircleCenter(){
	const sg = new THREE.SphereGeometry(1, 32, 32);
	const sm = new THREE.MeshNormalMaterial();
	
	const circleCenter = new THREE.Mesh(sg, sm);
	circleCenter.visible = false;

	return circleCenter;
}

function createLine(){
	const geometry = new LineGeometry();

	geometry.setPositions([
		0, 0, 0,
		0, 0, 0,
	]);

	const material = new LineMaterial({ 
		color: 0xff0000, 
		linewidth: 2, 
		resolution:  new THREE.Vector2(1000, 1000),
		gapSize: 1,
		dashed: true,
	});

	material.depthTest = false;

	const line = new Line2(geometry, material);

	return line;
}

function createCircle(){

	const coordinates = [];

	let n = 128;
	for(let i = 0; i <= n; i++){
		let u0 = 2 * Math.PI * (i / n);
		let u1 = 2 * Math.PI * (i + 1) / n;

		let p0 = new THREE.Vector3(
			Math.cos(u0), 
			Math.sin(u0), 
			0
		);

		let p1 = new THREE.Vector3(
			Math.cos(u1), 
			Math.sin(u1), 
			0
		);

		coordinates.push(
			...p0.toArray(),
			...p1.toArray(),
		);
	}

	const geometry = new LineGeometry();
	geometry.setPositions(coordinates);

	const material = new LineMaterial({ 
		color: 0xff0000, 
		dashSize: 5, 
		gapSize: 2,
		linewidth: 2, 
		resolution:  new THREE.Vector2(1000, 1000),
	});

	material.depthTest = false;

	const line = new Line2(geometry, material);
	line.computeLineDistances();

	return line;

}

function createAzimuth(){

	const azimuth = {
		label: null,
		center: null,
		target: null,
		north: null,
		centerToNorth: null,
		centerToTarget: null,
		centerToTargetground: null,
		targetgroundToTarget: null,
		circle: null,

		node: null,
	};

	const sg = new THREE.SphereGeometry(1, 32, 32);
	const sm = new THREE.MeshNormalMaterial();

	{
		const label = new TextSprite("");

		label.setTextColor({r: 34, g: 34, b: 34, a: 1.0});
		label.setBorderColor({r: 0, g: 115, b: 169, a: 1.0});
		label.setBackgroundColor({r: 255, g: 255, b: 255, a: 1.0});
		label.fontsize = 16;
		label.material.depthTest = false;
		label.material.opacity = 1;

		azimuth.label = label;
	}

	azimuth.center = new THREE.Mesh(sg, sm);
	azimuth.target = new THREE.Mesh(sg, sm);
	azimuth.north = new THREE.Mesh(sg, sm);
	azimuth.centerToNorth = createLine();
	azimuth.centerToTarget = createLine();
	azimuth.centerToTargetground = createLine();
	azimuth.targetgroundToTarget = createLine();
	azimuth.circle = createCircle();

	azimuth.node = new THREE.Object3D();
	azimuth.node.add(
		azimuth.centerToNorth,
		azimuth.centerToTarget,
		azimuth.centerToTargetground,
		azimuth.targetgroundToTarget,
		azimuth.circle,
		azimuth.label,
		azimuth.center,
		azimuth.target,
		azimuth.north,
	);

	return azimuth;
}

export class Measure extends THREE.Object3D {
	constructor () {
		super();

		this.constructor.counter = (this.constructor.counter === undefined) ? 0 : this.constructor.counter + 1;

		this.name = 'Measure_' + this.constructor.counter;
		this.points = [];
		this._showDistances = true;
		this._showCoordinates = false;
		this._showArea = false;
		this._closed = true;
		this._showAngles = false;
		this._showCircle = false;
		this._showHeight = false;
		this._showEdges = true;
		this._showSnap = null;
		this._showAzimuth = false;
		this.maxMarkers = Number.MAX_SAFE_INTEGER;

		this.sphereGeometry = new THREE.SphereGeometry(0.4, 10, 10);
		this.color = new THREE.Color(0xff0000);

		this.spheres = [];
		this.edges = [];
		this.sphereLabels = [];
		this.edgeLabels = [];
		this.angleLabels = [];
		this.coordinateLabels = [];

		this.heightEdge = createHeightLine();
		this.heightLabel = createHeightLabel();
		this.heightLabel2 = createHeightLabel();
		this.heightLabel3 = createHeightLabel();
		this.measureDataGroup = new THREE.Group();
		this.areaFill = createAreaFill();
		this.areaLabel = createAreaLabel();
		this.circleRadiusLabel = createCircleRadiusLabel();
		this.circleRadiusLine = createCircleRadiusLine();
		this.circleLine = createCircleLine();
		this.circleCenter = createCircleCenter();

		this.azimuth = createAzimuth();
		this.volProcess2Value = null
		this.volProcessValue = null
		this.volProcessValueCut = null

		this.add(this.heightEdge);
		this.add(this.heightLabel);
		this.add(this.heightLabel2);
		this.add(this.heightLabel3);
		this.add(this.measureDataGroup);
		this.add(this.areaFill);
		this.add(this.areaLabel);
		this.add(this.circleRadiusLabel);
		this.add(this.circleRadiusLine);
		this.add(this.circleLine);
		this.add(this.circleCenter);

		this.add(this.azimuth.node);
		if (showSnapValue) {
			this.snapCircle = new THREE.Mesh(new THREE.RingGeometry( 0.095, 0.08, 16, 1 ), new THREE.MeshBasicMaterial( { color: 0xff0000, side: THREE.DoubleSide } ));
			this.snapCircle.visible = false;
			this.add(this.snapCircle);
		}

		this.pipeDetect = new THREE.Mesh( new THREE.TorusGeometry( 1.0, 0.01, 8, 32 ), new THREE.MeshBasicMaterial( { color: 0xffff77 } ) );
		this.pipeDetect.visible = false;
		this.add(this.pipeDetect);
		this.pipeDetect2 = new THREE.Mesh( new THREE.TorusGeometry( 1.0, 0.01, 8, 32 ), new THREE.MeshBasicMaterial( { color: 0xffff77 } ) );
		this.pipeDetect2.visible = false;
		this.add(this.pipeDetect2);
		this.pipeDetect3 = new THREE.Mesh( new THREE.TorusGeometry( 1.0, 0.01, 8, 32 ), new THREE.MeshBasicMaterial( { color: 0x77ff77 } ) );
		this.pipeDetect3.visible = false;
		this.add(this.pipeDetect3);
		this.pipeDetect4 = new THREE.Mesh( new THREE.TorusGeometry( 1.0, 0.01, 8, 32 ), new THREE.MeshBasicMaterial( { color: 0x77ff77 } ) );
		this.pipeDetect4.visible = false;
		this.add(this.pipeDetect4);

		this.pipeDetectCenterLine = new Line2( new LineGeometry(), new LineMaterial( { color: 0xffff77, linewidth: 1, resolution:  new THREE.Vector2(1000, 1000), dashed: true, dashSize: 5, gapSize: 2 } ) );
		this.pipeDetectCenterLine.visible = false;
		this.add(this.pipeDetectCenterLine);
		this.pipeDetectCenterLine1 = new Line2( new LineGeometry(), new LineMaterial( { color: 0xffff77, linewidth: 1, resolution:  new THREE.Vector2(1000, 1000), dashed: true, dashSize: 5, gapSize: 2 } ) );
		this.pipeDetectCenterLine1.visible = false;
		this.add(this.pipeDetectCenterLine1);
		this.pipeDetectCenterLine2 = new Line2( new LineGeometry(), new LineMaterial( { color: 0xffff77, linewidth: 1, resolution:  new THREE.Vector2(1000, 1000), dashed: true, dashSize: 5, gapSize: 2 } ) );
		this.pipeDetectCenterLine2.visible = false;
		this.add(this.pipeDetectCenterLine2);
	}

	createSphereMaterial () {
		let sphereMaterial = new THREE.MeshLambertMaterial({
			//shading: THREE.SmoothShading,
			color: this.color,
			depthTest: false,
			depthWrite: false}
		);

		return sphereMaterial;
	};

	addMarker (point) {
		if ((this.name == "PipeDetect" || this.name == "PipeDetect2") && this.points.length == 4)
		{
			return;
		}
		if (point.x != null) {
			point = {position: point};
		}else if(point instanceof Array){
			point = {position: new THREE.Vector3(...point)};
		}
		this.points.push(point);

		// sphere
		let sphere = new THREE.Mesh(this.sphereGeometry, this.createSphereMaterial());

		this.add(sphere);
		this.spheres.push(sphere);

		{ // edges
			let lineGeometry = new LineGeometry();
			lineGeometry.setPositions( [
					0, 0, 0,
					0, 0, 0,
			]);

			let lineMaterial = new LineMaterial({
				color: 0xff0000, 
				linewidth: 2, 
				resolution:  new THREE.Vector2(1000, 1000),
			});

			lineMaterial.depthTest = false;

			let edge = new Line2(lineGeometry, lineMaterial);
			edge.visible = true;

			this.add(edge);
			this.edges.push(edge);
		}

		{ // edge labels
			let edgeLabel = new TextSprite();
			// edgeLabel.setBorderColor({r: 0, g: 0, b: 0, a: 1.0});
			// edgeLabel.setBackgroundColor({r: 0, g: 0, b: 0, a: 1.0});
			edgeLabel.setTextColor({r: 34, g: 34, b: 34, a: 1.0});
			edgeLabel.setBorderColor({r: 0, g: 115, b: 169, a: 1.0});
			edgeLabel.setBackgroundColor({r: 255, g: 255, b: 255, a: 1.0});
			edgeLabel.material.depthTest = false;
			edgeLabel.visible = false;
			edgeLabel.fontsize = 16;
			this.edgeLabels.push(edgeLabel);
			this.add(edgeLabel);
		}

		{ // angle labels
			let angleLabel = new TextSprite();
			// angleLabel.setBorderColor({r: 0, g: 0, b: 0, a: 1.0});
			// angleLabel.setBackgroundColor({r: 0, g: 0, b: 0, a: 1.0});
			angleLabel.setTextColor({r: 34, g: 34, b: 34, a: 1.0});
			angleLabel.setBorderColor({r: 0, g: 115, b: 169, a: 1.0});
			angleLabel.setBackgroundColor({r: 255, g: 255, b: 255, a: 1.0});
			angleLabel.fontsize = 16;
			angleLabel.material.depthTest = false;
			angleLabel.material.opacity = 1;
			angleLabel.visible = false;
			this.angleLabels.push(angleLabel);
			this.add(angleLabel);
		}

		{ // coordinate labels
			let coordinateLabel = new TextSprite();
			coordinateLabel.setBorderColor({r: 0, g: 0, b: 0, a: 1.0});
			coordinateLabel.setBackgroundColor({r: 0, g: 0, b: 0, a: 1.0});
			coordinateLabel.fontsize = 16;
			coordinateLabel.material.depthTest = false;
			coordinateLabel.material.opacity = 1;
			coordinateLabel.visible = false;
			this.coordinateLabels.push(coordinateLabel);
			this.add(coordinateLabel);
		}

		{ // Event Listeners
			let drag = (e) => {
				let I = Utils.getMousePointCloudIntersection(
					e.drag.end, 
					e.viewer.scene.getActiveCamera(), 
					e.viewer, 
					e.viewer.scene.pointclouds,
					{pickClipped: true});

				if (I) {
					let i = this.spheres.indexOf(e.drag.object);
					if (i !== -1) {
						let point = this.points[i];
						
						// loop through current keys and cleanup ones that will be orphaned
						for (let key of Object.keys(point)) {
							if (!I.point[key]) {
								delete point[key];
							}
						}

						for (let key of Object.keys(I.point).filter(e => e !== 'position')) {
							point[key] = I.point[key];
						}
						if (e.viewer != null && showSnapValue) {
							// Try to snap to measurements
							let minDist = 0;
							let foundPosition = null;
							for (let m = 0; m < e.viewer.scene.measurements.length; m++) {
								let thatMeasure = e.viewer.scene.measurements[m];
								for (let p = 0; p < thatMeasure.points.length; p++) {
									let thatPoint = thatMeasure.points[p];
									let dx = thatPoint.position.x - I.location.x;
									let dy = thatPoint.position.y - I.location.y;
									let dz = thatPoint.position.z - I.location.z;
									let dd = dx*dx + dy*dy + dz*dz;
									let d = Math.sqrt(dd);
									// if ((this.id == thatMeasure.id && index != p) || (this.id != thatMeasure.id )) { // Snap to same poly
									if (this.id != thatMeasure.id) { // Snap only to other polys
										if (d < 0.15 && (d < minDist || foundPosition == null)) {
											minDist = d;
											foundPosition = thatPoint.position;
										}
									}
								}
							}
							if (showSnapValue) {
								if (foundPosition != null) {
									// position.copy(foundPosition);
									I.location.copy(foundPosition);
									this.snapCircle.position.copy(foundPosition);
									this.snapCircle.visible = true;
								} else {
									this.snapCircle.visible = false;
								}
							}	else {
								if (foundPosition != null) {
									position.copy(foundPosition);
								}
							}
						}

						if (this.name == 'Point2Mesh')
						{
							// Measure to nearest orthogonal Mesh face
							var res = this.FindNearestOrthogonalMeshFacePoint(e.viewer, I.location);
							if (res != null)
							{
								if (this.points.length == 1)
								{
									// Add point2
									this.addMarker(this.points[this.points.length - 1].position.clone());
								}
								this.setPosition(this.points.length - 1, res);
							}
						}

						this.setPosition(i, I.location);
					}
				}
			};

			let drop = e => {
				let i = this.spheres.indexOf(e.drag.object);
				if (i !== -1) {
					this.dispatchEvent({
						'type': 'marker_dropped',
						'measurement': this,
						'index': i
					});
				}
				if (this.name == "PipeDetect2"/* && this.points.length == 4*/)
				{
					if (i == 0 || i ==1)
					{
						var adjust = this.AdjustPipeDirection(viewer.scene.pointclouds[0], this.points[0].position, this.points[1].position);
						this.points[0].position.copy(adjust.A);
						this.points[1].position.copy(adjust.B);
					}
				}
			};

			let mouseover = (e) => e.object.material.emissive.setHex(0x888888);
			let mouseleave = (e) => e.object.material.emissive.setHex(0x000000);

			sphere.addEventListener('drag', drag);
			sphere.addEventListener('drop', drop);
			sphere.addEventListener('mouseover', mouseover);
			sphere.addEventListener('mouseleave', mouseleave);
		}

		let event = {
			type: 'marker_added',
			measurement: this,
			sphere: sphere
		};
		this.dispatchEvent(event);

		this.setMarker(this.points.length - 1, point);
	};

	removeMarker (index) {
		if (this.name == "PipeDetect" || this.name == "PipeDetect2")
		{
			return;
		}
		this.points.splice(index, 1);

		this.remove(this.spheres[index]);

		let edgeIndex = (index === 0) ? 0 : (index - 1);
		this.remove(this.edges[edgeIndex]);
		this.edges.splice(edgeIndex, 1);

		this.remove(this.edgeLabels[edgeIndex]);
		this.edgeLabels.splice(edgeIndex, 1);
		this.coordinateLabels.splice(index, 1);

		this.remove(this.angleLabels[index]);
		this.angleLabels.splice(index, 1);

		this.spheres.splice(index, 1);

		this.update();

		this.dispatchEvent({type: 'marker_removed', measurement: this});
	};

	setMarker (index, point) {
		this.points[index] = point;

		let event = {
			type: 'marker_moved',
			measure:	this,
			index:	index,
			position: point.position.clone()
		};
		this.dispatchEvent(event);

		this.update();
	}

	setPosition (index, position) {

		let point = this.points[index];
		point.position.copy(position);

		let event = {
			type: 'marker_moved',
			measure:	this,
			index:	index,
			position: position.clone()
		};
		this.dispatchEvent(event);

		this.update();
	};
	LineCutPlane(n, V0, P0, P1)
	{
		let w = new THREE.Vector3().subVectors(P0, V0);
		let u = new THREE.Vector3().subVectors(P1, P0);
		let dot1 = -n.dot(w);
		let dot2 = n.dot(u);
		let k = dot1 / dot2;
		let cut = new THREE.Vector3().addVectors(P0, u.multiplyScalar(k));
		return cut;
	};
	ProjectPointToLine(A, B, P)
	{
		let AB = new THREE.Vector3().subVectors(B, A);
		let AP = new THREE.Vector3().subVectors(P, A);
		let dot1 = AP.dot(AB);
		let dot2 = AB.dot(AB);
		let k = dot1 / dot2;
		let p = new THREE.Vector3().addVectors(A, AB.multiplyScalar(k));
		return p;
	};
	PointOnInterval(A, B, P)
	{
		let AB = new THREE.Vector3().subVectors(B, A);
		let AP = new THREE.Vector3().subVectors(P, A);
		let BP = new THREE.Vector3().subVectors(P, B);
		let lenAB = AB.length();
		let lenAP = AP.length();
		let lenBP = BP.length();

		if (lenAB * 1.05 >= lenAP + lenBP)
		{
			// Inside interval
			return 1;
		}
		else
		{
			// Outside..

			if (lenAP < lenBP)
			{
				// Negative. Is before start of interval
				return -1;
			}
			else
			{
				// Ok, since it is in the positive part
				return 1;
			}
		}
	};
	getArea () {
		if (this.points.length >= 3) {

			let A = this.points[0].position;
			let B = this.points[1].position;

			let BA = new THREE.Vector3().subVectors(B, A);

			let bestC = null;
			let bestCrossSq = 0;

			for (let i = 2; i < this.points.length; i++) {

				let Ctest = this.points[i].position;
				let CA = new THREE.Vector3().subVectors(Ctest, A);

				let cross = new THREE.Vector3().crossVectors(BA, CA);
				let crossSq = cross.lengthSq();

				if (crossSq > bestCrossSq) {
					bestCrossSq = crossSq;
					bestC = Ctest;
				}
			}

			if (bestC === null) {
				return 0; // all points are collinear
			}

			let C = bestC;
			let CA = new THREE.Vector3().subVectors(C, A);				

			let planeNormal = new THREE.Vector3(0,0,0);
			planeNormal.crossVectors(BA, CA);
			planeNormal.normalize();
			let planeYAxis = BA.clone();
			planeYAxis.normalize();
			let planeXAxis = new THREE.Vector3(0,0,0);
			planeXAxis.crossVectors(BA, planeNormal);
			
			let relbuf = [];
			for (let i = 0; i < this.points.length; i++) {
				let p = this.points[i].position;
				let projP = this.LineCutPlane(planeNormal, A, p, new THREE.Vector3().subVectors(p, planeNormal));
				
				let A1 = new THREE.Vector3().addVectors(A, planeYAxis);
				let A2 = new THREE.Vector3().addVectors(A, planeXAxis);
				let projOnYAxis = this.ProjectPointToLine(A, A1, projP);
				let projOnXAxis = this.ProjectPointToLine(A, A2, projP);
				
				let relativeX = new THREE.Vector3().subVectors(projP, projOnYAxis).length() * this.PointOnInterval(A, A2, projOnXAxis);
				let relativeY = new THREE.Vector3().subVectors(projP, projOnXAxis).length() * this.PointOnInterval(A, A1, projOnYAxis);
				relbuf.push({x: relativeX, y: relativeY});
			}
			
			let area = 0;
			let p2 = relbuf[0];
			for (let i = 0; i < this.points.length; i++) {
				let p1 = relbuf[i];
				area += (p1.x * p2.y) - (p1.y * p2.x);
				p2 = p1;
			}

			return Math.abs(area / 2);
		} else {
			return 0;
		}
	};
	
	AreaTriangle(A, B, C)
	{
		var AB = new THREE.Vector3().subVectors(B, A);
		var AC = new THREE.Vector3().subVectors(C, A);
		var P = new THREE.Vector3().addVectors(AB.clone().multiplyScalar(AC.dot(AB) / AB.dot(AB)), A);//A + dot(AP, AB) / dot(AB, AB) * AB
		return AB.length() * new THREE.Vector3().subVectors(C, P).length() * 0.5;
	};
	IsPointInTriangle(A, B, C, projP)
	{
		var area1 = this.AreaTriangle(new THREE.Vector3().subVectors(B, A), new THREE.Vector3().subVectors(projP, A), new THREE.Vector3().subVectors(projP, B));
		var area2 = this.AreaTriangle(new THREE.Vector3().subVectors(C, B), new THREE.Vector3().subVectors(projP, B), new THREE.Vector3().subVectors(projP, C));
		var area3 = this.AreaTriangle(new THREE.Vector3().subVectors(A, C), new THREE.Vector3().subVectors(projP, C), new THREE.Vector3().subVectors(projP, A));
		return (area1 + area2 + area3 <= this.AreaTriangle(A, B, C) * 1.10);
	};		
	FindNearestOrthogonalMeshFacePoint(viewer, p1)
	{
		var nearestPoint = null;
		var minDist = -1;
		const otherMeshList = viewer.scene.scene.children.filter(x => x.type == "Mesh"/* && x.uuid != p1.uuid && x.uuid != p2.uuid*/);
		for(var c in otherMeshList)
		{
			var mesh = otherMeshList[c];

			if (mesh.geometry.attributes != undefined)
			{
				const posArr = mesh.geometry.attributes.position;
				var indexList = mesh.geometry.getIndex();

				for(var i = 0; i < indexList.count; i += 3)
				{
					var a = indexList.array[i + 0] * 3;
					var b = indexList.array[i + 1] * 3;
					var c = indexList.array[i + 2] * 3;

					var A = new THREE.Vector3(
						posArr.array[a + 0] + mesh.position.x,
						posArr.array[a + 1] + mesh.position.y,
						posArr.array[a + 2] + mesh.position.z);
					var B = new THREE.Vector3(
						posArr.array[b + 0] + mesh.position.x,
						posArr.array[b + 1] + mesh.position.y,
						posArr.array[b + 2] + mesh.position.z);
					var C = new THREE.Vector3(
						posArr.array[c + 0] + mesh.position.x,
						posArr.array[c + 1] + mesh.position.y,
						posArr.array[c + 2] + mesh.position.z);

					var AB = new THREE.Vector3().subVectors(B, A);
					var AC = new THREE.Vector3().subVectors(C, A);
					var nvec = new THREE.Vector3();
					nvec.crossVectors(AB, AC);

					var pointPlaneDir = new THREE.Vector3().subVectors(p1, nvec);
					var projP = this.LineCutPlane(nvec, A, p1, pointPlaneDir);

					if (this.IsPointInTriangle(A, B, C, projP))
					{
						var dist = p1.distanceTo(projP);
						if (minDist == -1 || dist < minDist)
						{
							minDist = dist;
							nearestPoint = projP.clone();
						}
					}
				}
			}
		}
		return nearestPoint;
	};

	removeMesh(mesh) {
		if (mesh.name == "Volume") {
			mesh.volumeCut = 0.00;
			mesh.volumeFill = 0.00;
		}

		mesh.children.forEach(group => {
			if (group.isGroup) { // Ensure it's a group
				for (let i = group.children.length - 1; i >= 0; i--) {
					let item = group.children[i];
					if (item.name === "meshFace" || item.name === "meshWire" || item.name === "VerticalMeshFace") {
						group.remove(item); // Remove from the group
					}
				}
			}
		});
	};

	PointInPolygon(vs, point) {
		// ray-casting algorithm based on
		// http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html
		var x = point[0], y = point[1];
		var inside = false;
		for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
			var xi = vs[i][0], yi = vs[i][1];
			var xj = vs[j][0], yj = vs[j][1];
			
			var intersect = ((yi > y) != (yj > y))
				&& (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
			if (intersect) inside = !inside;
		}
		return inside;
	};

	addMeshFace (v1, v2, v3, nameFace, colorFace, box) {

		var geom = new THREE.Geometry();
		let color = colorFace;

		geom.vertices.push(v1);
		geom.vertices.push(v3);
		geom.vertices.push(v2);

		geom.faces.push( new THREE.Face3( 0, 1, 2 ) );
		geom.computeFaceNormals();

		const material = new THREE.MeshPhongMaterial({
			color,
			opacity: 0.4,
			transparent: true,
			side: THREE.DoubleSide
		  });

		var edge = new THREE.Mesh( geom, material );

		edge.position.copy(box.min);

		edge.name = nameFace
		edge.visible = true;

		this.measureDataGroup.add(edge);
		this.edges.push(edge);
	};
		volProcess(meshVolume, volumeStep) {
		//get polyline base
		var polyline = meshVolume
		var baseCoords = [];
		var listBasePoints = [];
		var listPointBox = [];
		var baseFence = [];
		var listDecim = [];
		var decimate = 30;
		var rangeBase = 100;
		var listProjFence = []
		var decim = volumeStep;
		var fillVol = 0;
		var cutVol = 0;
		this.volProcessValue = fillVol;
		this.volProcessValueCut = cutVol;

		meshVolume.removeMesh(meshVolume)

		if (polyline.points.length < 3) {
			return
		}

		var from;
		var to;

		//find the smaller side of the polyline
		for (let i = 0; i < polyline.points.length; i++) {
			if (i == polyline.points.length-1) {
				from = polyline.points[i].position;
				to = polyline.points[0].position;
				let dist = Math.sqrt((from.x - to.x) * (from.x - to.x) + (from.y - to.y) * (from.y - to.y));
				if (dist<rangeBase)  {
					rangeBase = dist;
				}
			} else {
				from = polyline.points[i].position;
				to = polyline.points[i+1].position;
				let dist = Math.sqrt((from.x - to.x) * (from.x - to.x) + (from.y - to.y) * (from.y - to.y));
				if (dist<rangeBase)  {
					rangeBase = dist;
				}
			}
		}

		//create interpolated point on the Baseline
		for (let i = 0; i < polyline.points.length; i++) {
			if (i == polyline.points.length-1) {
				from = polyline.points[i].position;
				to = polyline.points[0].position;
			} else {
				from = polyline.points[i].position;
				to = polyline.points[i+1].position;
			}
			baseFence.push([from.x,from.y]);
			let distance = Math.sqrt((from.x - to.x) * (from.x - to.x) + (from.y - to.y) * (from.y - to.y) + (from.z - to.z) * (from.z - to.z))
			// Base line part
			let nbInter = Math.floor(distance/rangeBase)
			for (let k = 0; k < nbInter; k++) {
				let deltaX = (to.x - from.x)/nbInter;
				let deltaY = (to.y - from.y)/nbInter;
				let deltaZ = (to.z - from.z)/nbInter;
				let ptInter = new THREE.Vector3(from.x + deltaX * k, from.y + deltaY * k, from.z + deltaZ * k);
				baseCoords.push(ptInter.x);
				baseCoords.push(ptInter.y);
				listBasePoints.push(ptInter);
			}
			// Mesh line part
			nbInter = Math.floor(distance/decim)
			for (let k = 0; k < nbInter; k++) {
				let deltaX = (to.x - from.x)/nbInter;
				let deltaY = (to.y - from.y)/nbInter;
				let deltaZ = (to.z - from.z)/nbInter;
				let ptInter = new THREE.Vector3(from.x + deltaX * k, from.y + deltaY * k, from.z + deltaZ * k);
				listProjFence.push([ptInter.x,ptInter.y,ptInter.z,,,]);
			}

		}

		//triangulation of the base
		const delaunayBase = new Delaunator(baseCoords);
		var delTriBase = [];
		var goodTriBase = []
		for (var k = 0; k < delaunayBase.triangles.length;k=k+3) {
			let p1 = delaunayBase.triangles[k];
			let x1 = listBasePoints[p1].x;
			let y1 = listBasePoints[p1].y;
			let z1 = listBasePoints[p1].z;
			let p2 = delaunayBase.triangles[k+1];
			let x2 = listBasePoints[p2].x;
			let y2 = listBasePoints[p2].y;
			let z2 = listBasePoints[p2].z;
			let p3 = delaunayBase.triangles[k+2];
			let x3 = listBasePoints[p3].x;
			let y3 = listBasePoints[p3].y;
			let z3 = listBasePoints[p3].z;
			//get center of the triangle
			let centreTrianglePoint = new THREE.Vector3((x1+x2+x3)/3, (y1+y2+y3)/3, (z1+z2+z3)/3);

			if (this.PointInPolygon(baseFence, [centreTrianglePoint.x, centreTrianglePoint.y])){
				goodTriBase.push(p1);
				goodTriBase.push(p2);
				goodTriBase.push(p3);
			} else {
				delTriBase.push(p1);
				delTriBase.push(p2);
				delTriBase.push(p3);
			}
		}

		let allowedNodes = ["r"];
		//get node
		let cloudOtree = viewer.scene.pointclouds[0].root;
		let stack = [];
		let listNode = [];
		for (let i = 0; i < 8; i++) {
			let child = cloudOtree.children[i];
			if (child) {
				stack.push(child);
				listNode.push(child);
			}
		}
		while (stack.length > 0) {
			let node = stack.pop();
			// add children that intersect the cutting plane
			for (let i = 0; i < 8; i++) {
				let child = node.children[i];
				if (child instanceof Potree.PointCloudOctreeNode) {
					stack.push(child);
					if (child.name.length < 20 ) {
						listNode.push(child);
					}
				}
			}
		}

		// Selected classifications
		let classifications = viewer.scene.pointclouds[0].material.classification;
		let visibleClasses = [];
		for (let classId in classifications) {
			if (classifications[classId].visible) {
				visibleClasses.push(parseInt(classId));
			}
		}

		//get all coordinate inside polyline
		var coords = [];
		var listPoints = [];

		for (var k = 0; k < listNode.length ;k=k+1) {
			let node = listNode[k].geometryNode
			//let pointCloud = node.getPointsInBox(node);
			let nodeMatrix = new THREE.Matrix4().makeTranslation(...node.boundingBox.min.toArray());
			let matrix = new THREE.Matrix4().multiplyMatrices(viewer.scene.pointclouds[0].matrixWorld, nodeMatrix);

			let view = new Float32Array(node.geometry.attributes.position.array);

			for (var i = 0; i < view.length; i=i+decimate+3) {
				// Filter points by enabled classes
				if(visibleClasses.includes(node.geometry.attributes.classification.array[i])) {
					let pos = new THREE.Vector3();
					pos.set(
						view[i * 3 + 0],
						view[i * 3 + 1],
						view[i * 3 + 2]);

					pos.applyMatrix4(matrix);
					if(this.PointInPolygon(baseFence, [pos.x, pos.y])){
						listPoints.push(pos);
						listPointBox.push(pos)
					}
				}
			}
		}

		let box = new THREE.Box3().setFromPoints(listPointBox);

		//decimate listing points
		let numAverage = []
		for (var k = 0; k < listPoints.length ;k=k+1) {
			let pt = listPoints[k]

			for (var w = 0; w < listProjFence.length ; w=w+1) {
				if (listProjFence[w][3]) {
					let currentDist = this.dist2d(listProjFence[w][0],listProjFence[w][1],listProjFence[w][3],listProjFence[w][4]);
					let testDist = this.dist2d(listProjFence[w][0],listProjFence[w][1],pt.x,pt.y);
					if (testDist<currentDist) {
						listProjFence[w][3] = pt.x
						listProjFence[w][4] = pt.y
						listProjFence[w][5] = pt.z
					}
				} else {
					listProjFence[w][3] = pt.x
					listProjFence[w][4] = pt.y
					listProjFence[w][5] = pt.z
				}
			}


			let row = parseFloat((Math.round(pt.x/decim)*decim).toFixed(2))
			let column = parseFloat((Math.round(pt.y/decim)*decim).toFixed(2))

			if (!this.PointInPolygon(baseFence, [row, column])){
				continue;
			}
			if (listDecim.length == 0) {
				listDecim.push(new THREE.Vector3(row, column, 0));
				numAverage.push(1);
				numAverage[0] -= 1
			}
			let m = 0;
			let exifFlag = false
			while (m < listDecim.length) {
				if (listDecim[m].x == row && listDecim[m].y == column) {
					listDecim[m].z = listDecim[m].z + pt.z
					numAverage[m] += 1
					exifFlag = true
					//m = listDecim.length
				}
				m=m+1
			}
			if (exifFlag == false) {
				listDecim.push(new THREE.Vector3(row, column, pt.z));
				numAverage.push(1);
			}
		}

		for (let w = 0; w < listProjFence.length; w++) {
			listDecim.push(new THREE.Vector3(listProjFence[w][0], listProjFence[w][1], listProjFence[w][5]));
		}

		for (var k = 0; k < listDecim.length ;k=k+1) {
			if (numAverage[k]){
				listDecim[k].z = listDecim[k].z/numAverage[k]
			}
			coords.push(listDecim[k].x);
			coords.push(listDecim[k].y);
		}
		var delaunay = Delaunator.from(
			listDecim.map(v => {
			  return [v.x, v.y];
			})
		  );
		//calcul volume ground
		var sumVolGround = 0
		var iT = 0
		let delTri = [];
		let goodTri = []
		for (var k = 0; k < delaunay.triangles.length;k=k+3) {
			let p1 = delaunay.triangles[k];
			let x1 = listDecim[p1].x;
			let y1 = listDecim[p1].y;
			let z1 = listDecim[p1].z;
			let p2 = delaunay.triangles[k+1];
			let x2 = listDecim[p2].x;
			let y2 = listDecim[p2].y;
			let z2 = listDecim[p2].z;
			let p3 = delaunay.triangles[k+2];
			let x3 = listDecim[p3].x;
			let y3 = listDecim[p3].y;
			let z3 = listDecim[p3].z;
			//get center of the triangle
			let centreTrianglePoint = new THREE.Vector3((x1+x2+x3)/3, (y1+y2+y3)/3, (z1+z2+z3)/3);
			if (this.PointInPolygon(baseFence, [centreTrianglePoint.x, centreTrianglePoint.y])){
				goodTri.push(p1);
				goodTri.push(p2);
				goodTri.push(p3);
			} else {
				delTri.push(p1);
				delTri.push(p2);
				delTri.push(p3);
			}
		}
		for (var k = 0; k < goodTri.length;k=k+3) {
			//coordinate points of the triangles
			let p1 = goodTri[k];
			let x1 = listDecim[p1].x;
			let y1 = listDecim[p1].y;
			let z1 = listDecim[p1].z;
			let point1 = new THREE.Vector3(x1, y1, z1);
			point1.sub(box.min)
			let p2 = goodTri[k+1];
			let x2 = listDecim[p2].x;
			let y2 = listDecim[p2].y;
			let z2 = listDecim[p2].z;
			let point2 = new THREE.Vector3(x2, y2, z2);
			point2.sub(box.min)
			let p3 = goodTri[k+2];
			let x3 = listDecim[p3].x;
			let y3 = listDecim[p3].y;
			let z3 = listDecim[p3].z;
			let point3 = new THREE.Vector3(x3, y3, z3)
			point3.sub(box.min)
			//get center of the triangle
			let centreTrianglePoint = new THREE.Vector3((x1+x2+x3)/3, (y1+y2+y3)/3, (z1+z2+z3)/3)
			let triangleBase = this.getTriangle(centreTrianglePoint, goodTriBase, listBasePoints)
			let colorMesh = 0xFFFFFF

			if (!triangleBase){
				continue;
			} else {
				iT += 1;
			}
			let zSurf = this.projPointToSurface(centreTrianglePoint, triangleBase, listBasePoints)
			let heightVolume = centreTrianglePoint.z - zSurf
			let volTriangle = this.areaTri(x1,y1,x2,y2,x3,y3)*heightVolume

			if (heightVolume > 0) {
				cutVol += volTriangle;
				colorMesh = 0x408D78

			}
			if (heightVolume < 0) {
				fillVol += volTriangle;
				colorMesh = 0xCC0033
			}
			meshVolume.addMeshFace(point1,point2,point3,"meshFace",colorMesh,box);
		}

		meshVolume.volumeCut = cutVol;
		meshVolume.volumeFill = fillVol;
		this.volProcessValue = fillVol;
		this.volProcessValueCut = cutVol;

		//let elCutVol = this.elContent.find(`#measurement_cut`);
		//elCutVol.html(this.measurement.volumeCut.toFixed(3));
		//let elFillVol = this.elContent.find(`#measurement_fill`);
		//elFillVol.html(this.measurement.volumeFill.toFixed(3));

		meshVolume.name = "VolProcess";

		/*
		for (var k = 0; k < goodTriBase.length;k=k+3) {
			let p1 = goodTriBase[k];
			let x1 = listBasePoints[p1].x;
			let y1 = listBasePoints[p1].y;
			let z1 = listBasePoints[p1].z;
			let point1 = new THREE.Vector3(x1, y1, z1);
			let p2 = goodTriBase[k+1];
			let x2 = listBasePoints[p2].x;
			let y2 = listBasePoints[p2].y;
			let z2 = listBasePoints[p2].z;
			let point2 = new THREE.Vector3(x2, y2, z2);
			let p3 = goodTriBase[k+2];
			let x3 = listBasePoints[p3].x;
			let y3 = listBasePoints[p3].y;
			let z3 = listBasePoints[p3].z;
			let point3 = new THREE.Vector3(x3, y3, z3)
			meshVolume.addWireframeFace(point1,point2,point3);
		}*/

		for (var k = 0; k < listProjFence.length;k=k+1) {
			var color = 0xFFFFFF
			if (k == listProjFence.length-1) {
				let x1 = listProjFence[k][0];
				let y1 = listProjFence[k][1];
				let z1 = listProjFence[k][2];
				let point1 = new THREE.Vector3(x1, y1, z1);
				point1.sub(box.min)
				let x2 = listProjFence[0][0];
				let y2 = listProjFence[0][1];
				let z2 = listProjFence[0][2];
				let point2 = new THREE.Vector3(x2, y2, z2);
				point2.sub(box.min)
				let x3 = listProjFence[k][0];
				let y3 = listProjFence[k][1];
				let z3 = listProjFence[k][5];
				let point3 = new THREE.Vector3(x3, y3, z3)
				point3.sub(box.min)
				if (point1.z>point3.z){
					color = 0xCC0033
				} else {
					color = 0x408D78
				}
				meshVolume.addMeshFace(point1,point2,point3,"VerticalMeshFace",color,box);
				x1 = listProjFence[0][0];
				y1 = listProjFence[0][1];
				z1 = listProjFence[0][2];
				point1 = new THREE.Vector3(x1, y1, z1);
				point1.sub(box.min)
				x2 = listProjFence[0][0];
				y2 = listProjFence[0][1];
				z2 = listProjFence[0][5];
				point2 = new THREE.Vector3(x2, y2, z2);
				point2.sub(box.min)
				x3 = listProjFence[k][0];
				y3 = listProjFence[k][1];
				z3 = listProjFence[k][5];
				point3 = new THREE.Vector3(x3, y3, z3)
				point3.sub(box.min)
				if (point1.z>point2.z){
					color = 0xCC0033
				} else {
					color = 0x408D78
				}
				meshVolume.addMeshFace(point1,point2,point3,"VerticalMeshFace",color,box);
			} else {
				let x1 = listProjFence[k][0];
				let y1 = listProjFence[k][1];
				let z1 = listProjFence[k][2];
				let point1 = new THREE.Vector3(x1, y1, z1);
				point1.sub(box.min)
				let x2 = listProjFence[k+1][0];
				let y2 = listProjFence[k+1][1];
				let z2 = listProjFence[k+1][2];
				let point2 = new THREE.Vector3(x2, y2, z2);
				point2.sub(box.min)
				let x3 = listProjFence[k][0];
				let y3 = listProjFence[k][1];
				let z3 = listProjFence[k][5];
				let point3 = new THREE.Vector3(x3, y3, z3)
				point3.sub(box.min)
				if (point1.z>point3.z){
					color = 0xCC0033
				} else {
					color = 0x408D78
				}
				meshVolume.addMeshFace(point1,point2,point3,"VerticalMeshFace",color,box);
				x1 = listProjFence[k+1][0];
				y1 = listProjFence[k+1][1];
				z1 = listProjFence[k+1][2];
				point1 = new THREE.Vector3(x1, y1, z1);
				point1.sub(box.min)
				x2 = listProjFence[k+1][0];
				y2 = listProjFence[k+1][1];
				z2 = listProjFence[k+1][5];
				point2 = new THREE.Vector3(x2, y2, z2);
				point2.sub(box.min)
				x3 = listProjFence[k][0];
				y3 = listProjFence[k][1];
				z3 = listProjFence[k][5];
				point3 = new THREE.Vector3(x3, y3, z3)
				point3.sub(box.min)
				if (point1.z>point2.z){
					color = 0xCC0033
				} else {
					color = 0x408D78
				}
				meshVolume.addMeshFace(point1,point2,point3,"VerticalMeshFace",color,box);
			}
		}
		return {fillVol: fillVol, cutVol: cutVol};
	};
	dist2d(Ax,Ay,Bx,By) {
		let dist = Math.sqrt((Ax - Bx) * (Ax - Bx) + (Ay - By) * (Ay - By))

		return dist
	};

	areaTri(Ax,Ay,Bx,By,Cx,Cy) {
		let area = Math.abs((Ax*(By-Cy)+Bx*(Cy-Ay)+Cx*(Ay-By))/2);

		return area
	};

	getTriangle(point, trianglesBase, listBasePoints) {
		for (var k = 0; k < trianglesBase.length;k=k+3) {
			let baseFence = []
			let p1 = trianglesBase[k];
			let A = listBasePoints[p1]
			baseFence.push([A.x,A.y]);
			let p2 = trianglesBase[k+1];
			let B = listBasePoints[p2]
			baseFence.push([B.x,B.y]);
			let p3 = trianglesBase[k+2];
			let C = listBasePoints[p3]
			baseFence.push([C.x,C.y]);

			if(this.PointInPolygon(baseFence, [point.x, point.y])){
				return [p1,p2,p3]
			}
		}
	};

	projPointToSurface(pt, surface, listBasePoints) {
		let A = listBasePoints[surface[0]]
		let B = listBasePoints[surface[1]]
		let C = listBasePoints[surface[2]]
		let d1 = Math.sqrt((pt.x - A.x) * (pt.x - A.x) + (pt.y - A.y) * (pt.y - A.y))
		let d2 = Math.sqrt((pt.x - B.x) * (pt.x - B.x) + (pt.y - B.y) * (pt.y - B.y))
		let d3 = Math.sqrt((pt.x - C.x) * (pt.x - C.x) + (pt.y - C.y) * (pt.y - C.y))
		let w1 = 1/d1
		let w2 = 1/d2
		let w3 = 1/d3
		let zInterpol= (w1*A.z + w2*B.z + w3*C.z) / (w1 + w2 + w3)

		return zInterpol
	};

	getTotalDistance () {
		if (this.points.length === 0) {
			return 0;
		}

		let distance = 0;

		for (let i = 1; i < this.points.length; i++) {
			let prev = this.points[i - 1].position;
			let curr = this.points[i].position;
			let d = prev.distanceTo(curr);

			distance += d;
		}

		if (this.closed && this.points.length > 1) {
			let first = this.points[0].position;
			let last = this.points[this.points.length - 1].position;
			let d = last.distanceTo(first);

			distance += d;
		}

		return distance;
	}

	getAngleBetweenLines (cornerPoint, point1, point2) {
		let v1 = new THREE.Vector3().subVectors(point1.position, cornerPoint.position);
		let v2 = new THREE.Vector3().subVectors(point2.position, cornerPoint.position);

		// avoid the error printed by threejs if denominator is 0
		const denominator = Math.sqrt( v1.lengthSq() * v2.lengthSq() );
		if(denominator === 0){
			return 0;
		}else{
			return v1.angleTo(v2);
		}
	};

	getAngle (index) {
		if (this.points.length < 3 || index >= this.points.length) {
			return 0;
		}

		let previous = (index === 0) ? this.points[this.points.length - 1] : this.points[index - 1];
		let point = this.points[index];
		let next = this.points[(index + 1) % (this.points.length)];

		return this.getAngleBetweenLines(point, previous, next);
	}

	// updateAzimuth(){
	// 	// if(this.points.length !== 2){
	// 	// 	return;
	// 	// }

	// 	// const azimuth = this.azimuth;

	// 	// const [p0, p1] = this.points;

	// 	// const r = p0.position.distanceTo(p1.position);
		
	// }

	createCircleBy3Points (p1, p2, p3) {
		// Normalvector
		var p1p2 = new THREE.Vector3().subVectors(p2, p1);
		var p1p3 = new THREE.Vector3().subVectors(p3, p1);
		var nvec = new THREE.Vector3(0,0,0);
		nvec.crossVectors(p1p2, p1p3);

		// Bisectors
		var p1p2Xn = new THREE.Vector3(0,0,0);
		p1p2Xn.crossVectors(p1p2, nvec);
		var p1p3Xn = new THREE.Vector3(0,0,0);
		p1p3Xn.crossVectors(p1p3, nvec);

		// Bisectors not parallel
		var a = new THREE.Vector3(0,0,0);
		a.crossVectors(p1p2Xn, p1p3Xn);
		var dot = a.dot(a);
		if (dot == 0)
		{
			return null;
		}
		else
		{
			// Line centers
			var p1p2H = p1p2.clone();
			p1p2H.multiplyScalar(0.5);
			var p1p2C = new THREE.Vector3().addVectors(p1, p1p2H);
			var p1p3H = p1p3.clone();
			p1p3H.multiplyScalar(0.5);
			var p1p3C = new THREE.Vector3().addVectors(p1, p1p3H);

			// Intersect 2 bisectors
			var b = new THREE.Vector3(0, 0, 0);
			b.crossVectors(new THREE.Vector3().subVectors(p1p3C, p1p2C), p1p3Xn);
			p1p2Xn.multiplyScalar(b.dot(a) / dot);

			var center = new THREE.Vector3().addVectors(p1p2C, p1p2Xn);
			var radius = center.distanceTo(p1);
			return {center, radius, nvec};
		}
	};

	renderDepthMap(pointcloud, camera, width, height)
	{
		const depthBuffer = new Array(width * height * 4).fill(Infinity);
		const projectionMatrix = camera.projectionMatrix.clone();
		const viewMatrix = new THREE.Matrix4().copy(camera.matrixWorldInverse);
		const worldToScreen = new THREE.Matrix4().multiplyMatrices(projectionMatrix, viewMatrix);

		{
			function waitForNodeLoad(node){
				return new Promise(resolve => {
					if (node.loaded) {
					resolve(node);
					} else {
					node.oneTimeLoadCallback = () => {
						resolve(node);
					};
					node.load();
					}
				});
			}
			async function loadAllNodesAsync(node) {
				await waitForNodeLoad(node);
				
				for (const child of Object.values(node.children)) {
					await loadAllNodesAsync(child);
				}
			}
			async function loadAllNodesWait(node)
			{
				await loadAllNodesAsync(node);
			}
			loadAllNodesWait(pointcloud.pcoGeometry.root);

				
			/*function loadAllGeometryNodes(node) {
				if (!node.loaded) {
					node.load();
				}
			
				for (let key in node.children) {
					const child = node.children[key];
					loadAllGeometryNodes(child);
				}
			}
			loadAllGeometryNodes(pointcloud.pcoGeometry.root);*/
		}

		{
			const pointRadius = 4; // 2*Radius in pixels
			const pixelWorldSize = 0.001; // World offset per pixel (tweak this)
			// Get camera basis vectors in world space
			const cameraRight = new THREE.Vector3();
			const cameraUp = new THREE.Vector3();
			camera.matrixWorld.extractBasis(cameraRight, cameraUp, new THREE.Vector3());
			const dx_world = cameraRight.clone().multiplyScalar(pixelWorldSize);
			const dy_world = cameraUp.clone().multiplyScalar(pixelWorldSize);

			function processNode(node, level)
			{

				if (!node || !node.geometryNode || !node.geometryNode.geometry.attributes.position)
				{
					return;
				}
				else
				{
					const time1 = performance.now();
					
					const positions = node.geometryNode.geometry.attributes.position.array;
					const bbMin = node.geometryNode.boundingBox.min;
				
					const local = new THREE.Vector3(0, 0, 0);
					var viewPos = new THREE.Vector3(0, 0, 0);
					var world = new THREE.Vector3(0, 0, 0);

					for (let i = 0; i < positions.length; i += 3)
					{
						local.x = positions[i] + bbMin.x;
						local.y = positions[i + 1] + bbMin.y;
						local.z = positions[i + 2] + bbMin.z;
				
						world = local.applyMatrix4(pointcloud.matrixWorld);
						
						viewPos.x = world.x;
						viewPos.y = world.y;
						viewPos.z = world.z;
						viewPos = viewPos.applyMatrix4(viewMatrix);
						if (viewPos.z <= -camera.near)
						{
							const clip = world.clone().applyMatrix4(worldToScreen);
							const ndc = clip.clone().divideScalar(clip.w || 1);
							const y = Math.round((1 - (ndc.y * 0.5 + 0.5)) * (height - 1));
							if (y >= 0 && y < height)
							{
								const x = Math.round((ndc.x * 0.5 + 0.5) * (width - 1));
								if (x >= 0 && x < width)
								{
									var i0 = 4 * (y * width + x);
									// Approximate offset in world space from splat center
									const cdx = camera.position.x - world.x;
									const cdy = camera.position.y - world.y;
									const cdz = camera.position.z - world.z;
									const newDepthSQ = (cdx * cdx + cdy * cdy + cdz * cdz);
									if (newDepthSQ < depthBuffer[i0 + 3])
									{
										depthBuffer[i0] = world.x;
										depthBuffer[i0 + 1] = world.y;
										depthBuffer[i0 + 2] = world.z;
										depthBuffer[i0 + 3] = newDepthSQ;
									}
								}
							}
						}
					}
					const time2 = performance.now();
//						console.log(level, 'Duration: ' + (time2 - time1) / 1000 + ' seconds');

					// Recursively process children
					if (node.children) {
						for (const child of node.children) {
							processNode(child, level + 1);
						}
					}
				}
			}
			processNode(pointcloud.root, 0); // Start from root and recurse

			/*{
				// Interpolation splats
				for (let y = 0; y < height; y++)
				{
					for (let x = 0; x < width; x++)
					{
						const i0 = 4 * (y * width + x);
						const depth = depthBuffer[i0 + 3];
						if (depth < Infinity)
						{
							for (let dy = -pointRadius; dy <= pointRadius; dy++)
							{
								var y1 = y + dy;
								if (y1 >= 0 && y1 < height)
								{
									for (let dx = -pointRadius; dx <= pointRadius; dx++)
									{
										var x1 = x + dx;
										if (x1 >= 0 && x1 < width)
										{
											const i1 = 4 * (y1 * width + x1);
											var depth1 = depthBuffer[i1 + 3];
											if (depthBuffer[i1 + 0] != Infinity)
											{
												if (depth < depth1)
												{
													depthBuffer[i1 + 3] = depth;
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}*/


		}


		return depthBuffer;
	}


	projectPointToSnapshot(pointWorld, camera, width, height)
	{
		// Clone to avoid modifying original
		const pos = pointWorld.clone();
		
		// 1. Apply view matrix (world → camera/view space)
		pos.applyMatrix4(camera.matrixWorldInverse);
		
		// 2. Apply projection matrix (view → clip space)
		pos.applyMatrix4(camera.projectionMatrix);
		pos.w = pos.w || 1;
		
		// 3. Perform perspective divide (clip space → NDC)
		const ndc = new THREE.Vector3( pos.x / pos.w, pos.y / pos.w, pos.z / pos.w );
		
		// 4. Convert NDC [-1,1] to pixel coordinates [0,width-1], [0,height-1]
		const x = Math.round((ndc.x * 0.5 + 0.5) * (width - 1));
		const y = Math.round((1 - (ndc.y * 0.5 + 0.5)) * (height - 1)); // note Y flip
		
		// 5. Return pixel coords and depth (distance from camera)
		return { x, y, depth: camera.position.distanceTo(pointWorld) };
	}

	scanDepthMap(A, B, pointcloud, viewer, width, height)
	{
		const camera = viewer.scene.getActiveCamera();

		const depthBuffer = this.renderDepthMap(pointcloud, camera, width, height);

		var validDepthBuffer = new Array(depthBuffer.length).fill(Infinity);

		var edgePoints = [[],[]];
		var scanPoints = [];
		{

			// Start a line in buffer...
			var pA = this.projectPointToSnapshot(A, camera, width, height);
			var pB = this.projectPointToSnapshot(B, camera, width, height);
			var dx = pB.x - pA.x;
			var dy = pB.y - pA.y;
			var l = Math.sqrt(dx * dx + dy * dy);
			dx = l == 0 ? 0 : dx / l;
			dy = l == 0 ? 0 : dy / l;
			if (dx != 0 || dy != 0)
			{
				for(var t=0; t <= 1.0; t += 0.01)
				{
					{
						var hitPoint = null;
						var fx = pA.x + (pB.x - pA.x) * t;
						var fy = pA.y + (pB.y - pA.y) * t;
						var fdepth = pA.depth + (pB.depth - pA.depth) * t;
						var fdepthSQ = fdepth * fdepth;
						if (t > 0)
						{
							// Point near line
							{
								var x = parseInt(fx);
								var y = parseInt(fy);
								var index = 4 * (y * width + x);
								var depthSQ = depthBuffer[index + 3];
								var ddSQ = depthSQ - fdepthSQ;
								if (ddSQ < 0.1 * 0.1)
								{
									hitPoint = new THREE.Vector3(depthBuffer[index], depthBuffer[index + 1], depthBuffer[index + 2]);
								}
							}
						}

						if (hitPoint != null && (dx != 0 || dy != 0))
						{
							validDepthBuffer[index] = depthBuffer[index];
							validDepthBuffer[index + 1] = depthBuffer[index + 1];
							validDepthBuffer[index + 2] = depthBuffer[index + 2];
							validDepthBuffer[index + 3] = depthBuffer[index + 3];
							// Scan in both orthogonal directions 
							var e = 0;
							for(var s = -1; s <= 1; s += 2)
							{
								var voidCnt = 0;
								var fx1 = fx;
								var fy1 = fy;
								var dx1 = dx *s;
								var dy1 = dy *s;
								var oldDepthSQ = fdepthSQ;
								var oldScanPoint = hitPoint;
								var localBuf = [];
								while(true)
								{
									if (voidCnt > 20)
									{
										break;
									}
									fx1 -= dy1;
									fy1 += dx1;
									var x = parseInt(fx1);
									var y = parseInt(fy1);
									if (x >= 0 && x < width && y >= 0 && y < height)
									{
										var index = 4 * (y * width + x);
										var depthSQ = depthBuffer[index + 3];
										if (depthSQ != Infinity)
										{
											var dDepthSQ = Math.abs(oldDepthSQ - depthSQ);
											//if (dDepth < 0.05 * 0.05)
											{
												var scanPoint = new THREE.Vector3(depthBuffer[index], depthBuffer[index + 1], depthBuffer[index + 2]);
												var dp = scanPoint.distanceTo(oldScanPoint);
												if (dp > 2.20 && dDepthSQ > 0.10 * 0.10)
												{
													break;
												}
												else
												{
//													if (dp < 0.10 && dDepthSQ < 0.10 * 0.10)
													{
														scanPoints.push(scanPoint);
														localBuf.push({x: x, y: y});
														oldDepthSQ = depthSQ;
														validDepthBuffer[index] = depthBuffer[index];
														validDepthBuffer[index + 1] = depthBuffer[index + 1];
														validDepthBuffer[index + 2] = depthBuffer[index + 2];
														validDepthBuffer[index + 3] = depthBuffer[index + 3];
													}
												}

												oldScanPoint = scanPoint;
											}
										}
										else
										{
											voidCnt++;
										}
									}
									else
									{
										break;
									}
								}
								if (localBuf.length > 0)
								{
									edgePoints[e].push(localBuf[localBuf.length - 1]);
								}
								e++;
							}
						}
					}
				}
			}
		}

		return { depthBuffer: validDepthBuffer, scanPoints, edgePoints };
	}

	straightenPoints2D(points)
	{
		// points = array of {x, y}

		// 1. Compute centroid
		let cx = 0, cy = 0;
		for (const p of points) {
			cx += p.x;
			cy += p.y;
		}
		cx /= points.length;
		cy /= points.length;

		// 2. Compute covariance matrix
		let Sxx = 0, Syy = 0, Sxy = 0;
		for (const p of points) {
			const dx = p.x - cx;
			const dy = p.y - cy;
			Sxx += dx * dx;
			Syy += dy * dy;
			Sxy += dx * dy;
		}

		// 3. Find dominant direction (eigenvector of covariance matrix)
		const theta = 0.5 * Math.atan2(2 * Sxy, Sxx - Syy);
		const dir = { x: Math.cos(theta), y: Math.sin(theta) };

		// 4. Project each point onto the line
		return points.map(p => {
			const dx = p.x - cx;
			const dy = p.y - cy;
			const t = dx * dir.x + dy * dir.y; // projection length
			return { x: cx + t * dir.x, y: cy + t * dir.y };
		});
	}

	AdjustPipeDirection (pointcloud, A, B) {
		console.log('AdjustPipeDirection 20251110_1')
		const camera = viewer.scene.getActiveCamera();

		let size = new THREE.Vector2();
		viewer.renderer.getSize(size);  // fills size.x, size.y
		console.log('map size', size.x, size.y);
		var width  = size.x;
		var height = size.y;

		var res = this.scanDepthMap(A, B, pointcloud, viewer, width, height);
		var newA = A.clone();
		var newB = B.clone();

		var previewPoints =[];
		var pA = this.projectPointToSnapshot(A, camera, width, height);
		var pB = this.projectPointToSnapshot(B, camera, width, height);

		var directions = [];
		for(var e = 0; e < 2; e++)
		{
			var direction = [];
			var points = res.edgePoints[e];
			if (points.length > 1)
			{
				points = this.straightenPoints2D(points);

				for(var i = 0; i < points.length - 1; i++)
				{
					var p0 = points[i];
					var p1 = points[i + 1];
					var ix0 = parseInt(p0.x);
					var iy0 = parseInt(p0.y);
					var ix1 = parseInt(p1.x);
					var iy1 = parseInt(p1.y);

					var index0 = 4 * (ix0 + iy0 * width);
					if (res.depthBuffer[index0 + 3] < Infinity)
					{
						var world = new THREE.Vector3(res.depthBuffer[index0], res.depthBuffer[index0 + 1], res.depthBuffer[index0 + 2]);
						previewPoints.push(world);
					}

					var dx = ix1 - ix0;
					var dy = iy1 - iy0;
					direction.push({dx: dx, dy: dy, x: ix0, y: iy0});
				}
			}
			directions.push(direction);
		}
		console.log('directions', directions);

		var avgDx = 0;
		var avgDy = 0;
		for(var direction of directions)
		{
			var sumDx = 0;
			var sumDy = 0;
			for(var d of direction)
			{
				sumDx += d.dx;
				sumDy += d.dy;
			}
			avgDx += sumDx;
			avgDy += sumDy;
		}
		console.log('avg dir', avgDx / 2, avgDy / 2)


		{
			var midX = (directions[0][0].x + directions[1][0].x) / 2;
			var midY = (directions[0][0].y + directions[1][0].y) / 2;

			var indexF = -1;
			var ixB = parseInt(midX);
			var iyB = parseInt(midY);
			var minDist = Infinity;
			for(var y = 0; y < height; y++)
			{
				for(var x = 0; x < width; x++)
				{
					var index = 4 * (x + y * width);
					if (res.depthBuffer[index + 3] < Infinity)
					{
						var dx = x - ixB;
						var dy = y - iyB;
						var dist = dx * dx + dy * dy;
						if (dist < minDist)
						{
							minDist = dist;
							indexF = index;
						}
					}
				}
			}
			if (indexF != -1)
			{
				var world = new THREE.Vector3(res.depthBuffer[indexF], res.depthBuffer[indexF + 1], res.depthBuffer[indexF + 2]);
				console.log('found A!', world);
				previewPoints.push(world);
				newA = world;
			}
		}
				

		{
			var pA = this.projectPointToSnapshot(newA, camera, width, height);
			
			var indexF = -1;
			var ixB = parseInt(pA.x + avgDx / 2);
			var iyB = parseInt(pA.y + avgDy / 2);
			var minDist = Infinity;
			for(var y = 0; y < height; y++)
			{
				for(var x = 0; x < width; x++)
				{
					var index = 4 * (x + y * width);
					if (res.depthBuffer[index + 3] < Infinity)
					{
						var dx = x - ixB;
						var dy = y - iyB;
						var dist = dx * dx + dy * dy;
						if (dist < minDist)
						{
							minDist = dist;
							indexF = index;
						}
					}
				}
			}
			if (indexF != -1)
			{
				var world = new THREE.Vector3(res.depthBuffer[indexF], res.depthBuffer[indexF + 1], res.depthBuffer[indexF + 2]);
				console.log('found B!', world);
				previewPoints.push(world);
				newB = world;
			}
		}


		return  { A: newA, B: newB };
	}

	update () {
		if (this.points.length === 0) {
			this.areaFill.visible = false;
			return;
		} else if (this.points.length === 1) {
			this.areaFill.visible = false;
			let point = this.points[0];
			let position = point.position;
			this.spheres[0].position.copy(position);

			{ // coordinate labels
				let coordinateLabel = this.coordinateLabels[0];
				
				let msg = position.toArray().map(p => Utils.addCommas(p.toFixed(2))).join(" / ");
				coordinateLabel.setText(msg);

				coordinateLabel.visible = this.showCoordinates;
			}

			return;
		}

		if (this.points.length < 3) {
			this.areaFill.visible = false;
		}

		if (this.name == 'Point2Mesh')
		{
			var p0 = this.points[0].position.clone();
			var p1 = this.points[1].position.clone();
			// Measure to mesh
			let coordinateLabel = this.coordinateLabels[0];					
			{
				let distance = p0.distanceTo(p1);
				let suffix = "";
				if(this.lengthUnit != null && this.lengthUnitDisplay != null){
					distance = distance / this.lengthUnit.unitspermeter * this.lengthUnitDisplay.unitspermeter;  //convert to meters then to the display unit
					suffix = this.lengthUnitDisplay.code;
				}
				let txtLength = Utils.addCommas(distance.toFixed(3));
				coordinateLabel.setText(`${txtLength} ${suffix}`);
				coordinateLabel.visible = this.showDistances && (index < lastIndex || this.closed) && this.points.length >= 2 && distance > 0;						
			}
			coordinateLabel.visible = this.showCoordinates;
		}

		let lastIndex = this.points.length - 1;

		let centroid = new THREE.Vector3();
		for (let i = 0; i <= lastIndex; i++) {
			let point = this.points[i];
			centroid.add(point.position);
		}
		centroid.divideScalar(this.points.length);

		if (this.name == "PipeDetect" || this.name == "PipeDetect2")
		{
			for (let i = 0; i <= lastIndex; i++) {
				let point = this.points[i];
				let sphere = this.spheres[i];
				// spheres
				sphere.position.copy(point.position);
				sphere.material.color = this.color;
			}
			if (this.points.length > 1)
			{
				let point = this.points[0];
				let nextPoint = this.points[1];

				let edge = this.edges[0];
				edge.material.color = this.color;
				edge.position.copy(point.position);
				edge.geometry.setPositions([
					0, 0, 0,
					...nextPoint.position.clone().sub(point.position).toArray(),
				]);
				edge.geometry.verticesNeedUpdate = true;
				edge.geometry.computeBoundingSphere();
				edge.computeLineDistances();
				edge.visible = true;
				if(!this.showEdges){
					edge.visible = false;
				}
			}
		}
		else
		{
			for (let i = 0; i <= lastIndex; i++) {
				let index = i;
				let nextIndex = (i + 1 > lastIndex) ? 0 : i + 1;
				let previousIndex = (i === 0) ? lastIndex : i - 1;

				let point = this.points[index];
				let nextPoint = this.points[nextIndex];
				let previousPoint = this.points[previousIndex];

				let sphere = this.spheres[index];

				// spheres
				sphere.position.copy(point.position);
				sphere.material.color = this.color;

				{ // edges
					let edge = this.edges[index];

					edge.material.color = this.color;

					edge.position.copy(point.position);

					edge.geometry.setPositions([
						0, 0, 0,
						...nextPoint.position.clone().sub(point.position).toArray(),
					]);

					edge.geometry.verticesNeedUpdate = true;
					edge.geometry.computeBoundingSphere();
					edge.computeLineDistances();
					edge.visible = index < lastIndex || this.closed;
					
					if(!this.showEdges){
						edge.visible = false;
					}
				}

				{ // edge labels
					let edgeLabel = this.edgeLabels[i];

					let center = new THREE.Vector3().add(point.position);
					center.add(nextPoint.position);
					center = center.multiplyScalar(0.5);
					let distance = point.position.distanceTo(nextPoint.position);

					edgeLabel.position.copy(center);

					let suffix = "";
					if(this.lengthUnit != null && this.lengthUnitDisplay != null){
						distance = distance / this.lengthUnit.unitspermeter * this.lengthUnitDisplay.unitspermeter;  //convert to meters then to the display unit
						suffix = this.lengthUnitDisplay.code;
					}

					let txtLength = Utils.addCommas(distance.toFixed(3));
					edgeLabel.setText(`${txtLength} ${suffix}`);
					edgeLabel.visible = this.showDistances && (index < lastIndex || this.closed) && this.points.length >= 2 && distance > 0;
				}

				{ // angle labels
					let angleLabel = this.angleLabels[i];
					let angle = this.getAngleBetweenLines(point, previousPoint, nextPoint);

					let dir = nextPoint.position.clone().sub(previousPoint.position);
					dir.multiplyScalar(0.5);
					dir = previousPoint.position.clone().add(dir).sub(point.position).normalize();

					let dist = Math.min(point.position.distanceTo(previousPoint.position), point.position.distanceTo(nextPoint.position));
					dist = dist / 9;

					let labelPos = point.position.clone().add(dir.multiplyScalar(dist));
					angleLabel.position.copy(labelPos);

					let msg = Utils.addCommas((angle * (180.0 / Math.PI)).toFixed(1)) + '\u00B0';
					angleLabel.setText(msg);

					angleLabel.visible = this.showAngles && (index < lastIndex || this.closed) && this.points.length >= 3 && angle > 0;
				}
			}
		}

		{ // update height stuff
			let heightEdge = this.heightEdge;
			heightEdge.visible = this.showHeight;
			this.heightLabel.visible = this.showHeight;
			this.heightLabel2.visible = this.showHeight;
			this.heightLabel3.visible = this.showHeight;

			if (this.showHeight) {
				let sorted = this.points.slice().sort((a, b) => a.position.z - b.position.z);
				let lowPoint = sorted[0].position.clone();
				let highPoint = sorted[sorted.length - 1].position.clone();
				let min = lowPoint.z;
				let max = highPoint.z;
				let height = max - min;

				let start = new THREE.Vector3(highPoint.x, highPoint.y, min);
				let end = new THREE.Vector3(highPoint.x, highPoint.y, max);
				let otherLowPoint = new THREE.Vector3(lowPoint.x, lowPoint.y, min);

				let height2 = otherLowPoint.distanceTo(start);
				let height3 = otherLowPoint.distanceTo(end);

				heightEdge.position.copy(lowPoint);

				heightEdge.geometry.setPositions([
					0, 0, 0,
					...start.clone().sub(lowPoint).toArray(),
					...start.clone().sub(lowPoint).toArray(),
					...end.clone().sub(lowPoint).toArray(),
				]);

				heightEdge.geometry.verticesNeedUpdate = true;
				// heightEdge.geometry.computeLineDistances();
				// heightEdge.geometry.lineDistancesNeedUpdate = true;
				heightEdge.geometry.computeBoundingSphere();
				heightEdge.computeLineDistances();

				// heightEdge.material.dashSize = height / 40;
				// heightEdge.material.gapSize = height / 40;

				let heightLabelPosition = start.clone().add(end).multiplyScalar(0.5);
				this.heightLabel.position.copy(heightLabelPosition);
				let heightLabelPosition2 = otherLowPoint.clone().add(start).multiplyScalar(0.5);
				this.heightLabel2.position.copy(heightLabelPosition2);
				let heightLabelPosition3 = otherLowPoint.clone().add(end).multiplyScalar(0.5);
				this.heightLabel3.position.copy(heightLabelPosition3);

				let suffix = "";
				if(this.lengthUnit != null && this.lengthUnitDisplay != null){
					height = height / this.lengthUnit.unitspermeter * this.lengthUnitDisplay.unitspermeter;  //convert to meters then to the display unit
					height2 = height2 / this.lengthUnit.unitspermeter * this.lengthUnitDisplay.unitspermeter;  //convert to meters then to the display unit
					height3 = height3 / this.lengthUnit.unitspermeter * this.lengthUnitDisplay.unitspermeter;  //convert to meters then to the display unit
					suffix = this.lengthUnitDisplay.code;
				}

				let txtHeight = Utils.addCommas(height.toFixed(3));
				let txtHeight2 = Utils.addCommas(height2.toFixed(3));
				let txtHeight3 = Utils.addCommas(height3.toFixed(3));
				let msg = `${txtHeight} ${suffix}`;
				let msg2 = `${txtHeight2} ${suffix}`;
				let msg3 = `${txtHeight3} ${suffix}`;
				this.heightLabel.setText(msg);
				this.heightLabel2.setText(msg2);
				this.heightLabel3.setText(msg3);
			}
		}

		{ // update circle stuff
			const circleRadiusLabel = this.circleRadiusLabel;
			const circleRadiusLine = this.circleRadiusLine;
			const circleLine = this.circleLine;
			const circleCenter = this.circleCenter;

			const circleOkay = this.points.length === 3;

			circleRadiusLabel.visible = this.showCircle && circleOkay;
			circleRadiusLine.visible = this.showCircle && circleOkay;
			circleLine.visible = this.showCircle && circleOkay;
			circleCenter.visible = this.showCircle && circleOkay;

			if(this.showCircle && circleOkay){

				const A = this.points[0].position;
				const B = this.points[1].position;
				const C = this.points[2].position;
				const AB = B.clone().sub(A);
				const AC = C.clone().sub(A);
				const N = AC.clone().cross(AB).normalize();

				const center = Potree.Utils.computeCircleCenter(A, B, C);
				const radius = center.distanceTo(A);


				const scale = radius / 20;
				circleCenter.position.copy(center);
				circleCenter.scale.set(scale, scale, scale);

				//circleRadiusLine.geometry.vertices[0].set(0, 0, 0);
				//circleRadiusLine.geometry.vertices[1].copy(B.clone().sub(center));

				circleRadiusLine.geometry.setPositions( [
					0, 0, 0,
					...B.clone().sub(center).toArray()
				] );

				circleRadiusLine.geometry.verticesNeedUpdate = true;
				circleRadiusLine.geometry.computeBoundingSphere();
				circleRadiusLine.position.copy(center);
				circleRadiusLine.computeLineDistances();

				const target = center.clone().add(N);
				circleLine.position.copy(center);
				circleLine.scale.set(radius, radius, radius);
				circleLine.lookAt(target);
				
				circleRadiusLabel.visible = true;
				circleRadiusLabel.position.copy(center.clone().add(B).multiplyScalar(0.5));
				circleRadiusLabel.setText(`${radius.toFixed(3)}`);

			}
		}

		if (this.name == "PipeDetect" || this.name == "PipeDetect2")
		{ // Update pipe detect
			if (this.points.length >= 4)
			{
				this.pipeDetect.visible = false;
				this.pipeDetect2.visible = false;
				this.pipeDetect3.visible = false;
				this.pipeDetect4.visible = false;
				this.pipeDetectCenterLine.visible = false;
				this.pipeDetectCenterLine1.visible = false;
				this.pipeDetectCenterLine2.visible = false;

				var p1 = this.points[0].position;	// length point 1
				var p2 = this.points[1].position;	// length point 2
				var p3 = this.points[2].position;	// first known point in circle
				var p4 = this.points[3].position;	// second known point in circle

				// Long dir of cylinder
				var p1p2 = new THREE.Vector3().subVectors(p2, p1);
				var projPoint = new THREE.Vector3();
				{
					var p1p3 = new THREE.Vector3().subVectors(p3, p1);
					var nvec = new THREE.Vector3(0,0,0);
					nvec.crossVectors(p1p2, p1p3);
					// Project first circle point onto line
					var dot1312 = p1p3.dot(p1p2);
					var dot1212 = p1p2.dot(p1p2);
					var p1p2Scaled = p1p2.clone().multiplyScalar(dot1312 / dot1212);
					projPoint = new THREE.Vector3().addVectors(p1, p1p2Scaled);
				}
				// Long dir of cylinder
				var projPoint2 = new THREE.Vector3();
				{
					var p1p4 = new THREE.Vector3().subVectors(p4, p1);
					var nvec = new THREE.Vector3(0,0,0);
					nvec.crossVectors(p1p2, p1p4);
					// Project second circle point onto line
					var dot1412 = p1p4.dot(p1p2);
					var dot1212 = p1p2.dot(p1p2);
					var p1p2Scaled = p1p2.clone().multiplyScalar(dot1412 / dot1212);
					projPoint2 = new THREE.Vector3().addVectors(p1, p1p2Scaled);
				}
				// Move second circle point down in same level
				var dpv = new THREE.Vector3().subVectors(projPoint, projPoint2);
				var p4c = new THREE.Vector3().addVectors(p4, dpv);

				var res = this.createCircleBy3Points(p3, projPoint, p4c);
				if (res != null)
				{
					var center1 = res.center;
					var center2 = new THREE.Vector3().subVectors(center1, dpv);
					var center3 = new THREE.Vector3().addVectors(center1, new THREE.Vector3().subVectors(p1, projPoint));
					var center4 = new THREE.Vector3().addVectors(center2, new THREE.Vector3().subVectors(p2, projPoint2));

					// Set center and radius
					this.pipeDetect.position.copy(center1);
					this.pipeDetect.scale.setScalar(res.radius);
					// Rotate plane
					this.pipeDetect.rotation.setFromQuaternion(new THREE.Quaternion().setFromUnitVectors(new THREE.Vector3(0, 0, 1), res.nvec.clone().normalize()));

					// Set center and radius
					this.pipeDetect2.position.copy(center2);
					this.pipeDetect2.scale.setScalar(res.radius);
					// Rotate plane
					this.pipeDetect2.rotation.setFromQuaternion(new THREE.Quaternion().setFromUnitVectors(new THREE.Vector3(0, 0, 1), res.nvec.clone().normalize()));

					// Set center and radius
					this.pipeDetect3.position.copy(center3);
					this.pipeDetect3.scale.setScalar(res.radius);
					// Rotate plane
					this.pipeDetect3.rotation.setFromQuaternion(new THREE.Quaternion().setFromUnitVectors(new THREE.Vector3(0, 0, 1), res.nvec.clone().normalize()));

					// Set center and radius
					this.pipeDetect4.position.copy(center4);
					this.pipeDetect4.scale.setScalar(res.radius);
					// Rotate plane
					this.pipeDetect4.rotation.setFromQuaternion(new THREE.Quaternion().setFromUnitVectors(new THREE.Vector3(0, 0, 1), res.nvec.clone().normalize()));



					// Center line
					this.pipeDetectCenterLine.geometry.setPositions( [ 0,0,0, ...new THREE.Vector3().subVectors(center2, center1).toArray(),] );
					this.pipeDetectCenterLine.position.copy(center1);
					this.pipeDetectCenterLine.computeLineDistances();
					this.pipeDetectCenterLine.scale.set( 1, 1, 1 );
					
					// Center line1
					this.pipeDetectCenterLine1.geometry.setPositions( [ 0,0,0, ...new THREE.Vector3().subVectors(p3, center1).toArray(),] );
					this.pipeDetectCenterLine1.position.copy(center1);
					this.pipeDetectCenterLine1.computeLineDistances();
					this.pipeDetectCenterLine1.scale.set( 1, 1, 1 );

					// Center line2
					this.pipeDetectCenterLine2.geometry.setPositions( [ 0,0,0, ...new THREE.Vector3().subVectors(p4, center2).toArray(),] );
					this.pipeDetectCenterLine2.position.copy(center2);
					this.pipeDetectCenterLine2.computeLineDistances();
					this.pipeDetectCenterLine2.scale.set( 1, 1, 1 );

					// Adjust dir line to circle ends
					//this.points[0].position.copy(projPoint);
					//this.points[3].position.copy(projPoint2);


					this.pipeDetect.visible = true;
					this.pipeDetect2.visible = true;
					this.pipeDetect3.visible = true;
					this.pipeDetect4.visible = true;
					this.pipeDetectCenterLine.visible = true;
					this.pipeDetectCenterLine1.visible = true;
					this.pipeDetectCenterLine2.visible = true;

					// Circle areal
					var radius = res.radius;
					var area = Math.PI * res.radius * res.radius;
					this.pipeDetect.visible = true;
					let suffix = "";
					if(this.lengthUnit != null && this.lengthUnitDisplay != null){
						area = area / Math.pow(this.lengthUnit.unitspermeter, 2) * Math.pow(this.lengthUnitDisplay.unitspermeter, 2);  //convert to square meters then to the square display unit
						radius = radius / this.lengthUnit.unitspermeter * this.lengthUnitDisplay.unitspermeter;  //convert to meters then to the display unit;
						suffix = this.lengthUnitDisplay.code;
					}
					this.areaLabel.visible = this.showArea && this.points.length >= 4;
					this.areaLabel.position.copy(centroid);
					// let txtRadius = Utils.addCommas(radius.toFixed(3));
					// let txtArea = Utils.addCommas(area.toFixed(3));
					// let msg =  `Radius: ${txtRadius} ${suffix}  Areal: ${txtArea} ${suffix}\u00B2`;
					let txtDiameter = Utils.addCommas((radius * 2).toFixed(3));
					let msg =  `Diameter: ${txtDiameter} ${suffix}`;
					this.areaLabel.setText(msg);
				}
			}
		}
		else
		{ // update area label
			this.pipeDetect.visible = false;
			this.pipeDetect2.visible = false;
			this.pipeDetect3.visible = false;
			this.pipeDetect4.visible = false;
			this.pipeDetectCenterLine.visible = false;
			this.pipeDetectCenterLine1.visible = false;
			this.pipeDetectCenterLine2.visible = false;
			this.areaLabel.position.copy(centroid);
			this.areaLabel.visible = this.showArea && this.points.length >= 3;
			let area = this.getArea();

			let suffix = "";
			if(this.lengthUnit != null && this.lengthUnitDisplay != null){
				area = area / Math.pow(this.lengthUnit.unitspermeter, 2) * Math.pow(this.lengthUnitDisplay.unitspermeter, 2);  //convert to square meters then to the square display unit
				suffix = this.lengthUnitDisplay.code;
			}

			// let txtArea = Utils.addCommas(area.toFixed(1));
			// let msg =  `${txtArea} ${suffix}\u00B2`;
			// console.log('msg', msg)
			// this.areaLabel.setText(msg);
			let txtArea = Utils.addCommas(area.toFixed(1));
            if (this.volProcessValue != null && this.volProcessValueCut != null) {
				const getLang = window.location.href.split('/')[3]
                let txtVP = Utils.addCommas(Math.abs(this.volProcessValue.toFixed(1)));
                let txtVPC = Utils.addCommas(Math.abs(this.volProcessValueCut.toFixed(1)));
				let txtAreaLocalized = formatLabelNumberForLanguage(txtArea, getLang);
				let txtVPLocalized = formatLabelNumberForLanguage(txtVP, getLang);
				let txtVPCLocalized = formatLabelNumberForLanguage(txtVPC, getLang);
				let msg
				if (getLang === 'da') {
					msg =  {
						['Negativ volumen']: `${txtVPLocalized} ${suffix}\u00B3\n (+/- 15%)`,
						['Positiv volumen']: `${txtVPCLocalized} ${suffix}\u00B3\n (+/- 15%)`,
						Areal: `${txtAreaLocalized} ${suffix}\u00B2`
					}
				}	else {
					msg =  {
						['Negative Volume']: `${txtVP.replace('.', ',')} ${suffix}\u00B3\n (+/- 15%)`,
						['Positive Volume']: `${txtVPC.replace('.', ',')} ${suffix}\u00B3\n (+/- 15%)`,
						Area: `${txtArea.replace('.', ',')} ${suffix}\u00B2`
					}
				}
                this.areaLabel.setText(msg);
			} else {
				const getLang = window.location.href.split('/')[3]
				let txtAreaLocalized = formatLabelNumberForLanguage(txtArea, getLang);
				let msg
				if (getLang === 'da') {
					msg =  `${txtAreaLocalized} ${suffix}\u00B2`;
				}	else {
					msg =  `${txtArea} ${suffix}\u00B2`;
				}
                this.areaLabel.setText(msg);
            }
		}

		// this.updateAzimuth();
	};

	getAreaScreenData (camera) {
		if (this.points.length < 3 || !camera) {
			return null;
		}

		let screenPoints = [];
		let overlayPoints = [];

		for (let point of this.points) {
			let projectedPoint = point.position.clone().project(camera);
			if (!Number.isFinite(projectedPoint.x) || !Number.isFinite(projectedPoint.y) || !Number.isFinite(projectedPoint.z)) {
				return null;
			}

			screenPoints.push(new THREE.Vector2(projectedPoint.x, projectedPoint.y));

			let overlayPoint = new THREE.Vector3(projectedPoint.x, projectedPoint.y, -0.9);
			overlayPoint.unproject(camera);
			overlayPoints.push(overlayPoint);
		}

		return {screenPoints, overlayPoints};
	}

	updateAreaFill (camera) {
		let shouldShowAreaFill = this.showArea && this.points.length >= 3;
		if (!shouldShowAreaFill) {
			this.areaFill.visible = false;
			return;
		}

		let screenData = this.getAreaScreenData(camera);
		if (screenData === null) {
			this.areaFill.visible = false;
			return;
		}

		let triangles = THREE.ShapeUtils.triangulateShape(screenData.screenPoints, []);
		if (!triangles || triangles.length === 0) {
			this.areaFill.visible = false;
			return;
		}

		let positions = [];
		for (let triangle of triangles) {
			for (let index of triangle) {
				let point = screenData.overlayPoints[index];
				positions.push(...point.toArray());
			}
		}

		this.areaFill.geometry.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
		this.areaFill.geometry.computeBoundingSphere();
		this.areaFill.visible = true;
	}

	raycast (raycaster, intersects) {
		for (let i = 0; i < this.points.length; i++) {
			let sphere = this.spheres[i];

			sphere.raycast(raycaster, intersects);
		}

		// recalculate distances because they are not necessarely correct
		// for scaled objects.
		// see https://github.com/mrdoob/three.js/issues/5827
		// TODO: remove this once the bug has been fixed
		for (let i = 0; i < intersects.length; i++) {
			let I = intersects[i];
			I.distance = raycaster.ray.origin.distanceTo(I.point);
		}
		intersects.sort(function (a, b) { return a.distance - b.distance; });
	};

	get showCoordinates () {
		return this._showCoordinates;
	}

	set showCoordinates (value) {
		this._showCoordinates = value;
		this.update();
	}

	get showAngles () {
		return this._showAngles;
	}

	set showAngles (value) {
		this._showAngles = value;
		this.update();
	}

	get showCircle () {
		return this._showCircle;
	}

	set showCircle (value) {
		this._showCircle = value;
		this.update();
	}

	get showAzimuth(){
		return this._showAzimuth;
	}

	set showAzimuth(value){
		this._showAzimuth = value;
		this.update();
	}

	get showEdges () {
		return this._showEdges;
	}

	set showEdges (value) {
		this._showEdges = value;
		this.update();
	}

	get showSnap () {
		return showSnapValue;
	}

	set showSnap (value) {
		showSnapValue = value;
		this.update();
	}
	get showHeight () {
		return this._showHeight;
	}

	set showHeight (value) {
		this._showHeight = value;
		this.update();
	}

	get showArea () {
		return this._showArea;
	}

	set showArea (value) {
		this._showArea = value;
		this.update();
	}

	get closed () {
		return this._closed;
	}

	set closed (value) {
		this._closed = value;
		this.update();
	}

	get showDistances () {
		return this._showDistances;
	}

	set showDistances (value) {
		this._showDistances = value;
		this.update();
	}

}
